import React, { useContext, useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'

import { requestMyProfile } from 'api/user'
import { AuthContext } from 'providers/auth'

export const ProfileContext = React.createContext({})

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState({
    Role: {}, 
    Country: { iba_active: false }, 
    KbaPartners: [],
    firstName: '', 
    lastName: '', 
    id: ''
  })
  const { isAuthenticated } = useContext(AuthContext)

  const updateMyProfile = () => {
    requestMyProfile().then((newProfile) => {
      // Ensure Country and KbaPartners are properly structured
      const enhancedProfile = {
        ...newProfile,
        Country: newProfile.Country || { iba_active: false },
        KbaPartners: newProfile.KbaPartners || []
      }
      setProfile(enhancedProfile)
    })
  }

  useEffect(() => {
    if (isAuthenticated) {
      updateMyProfile()
    }
  }, [isAuthenticated])

  const contextValue = useMemo(() => ({
    profile,
    updateMyProfile
  }), [profile])

  if (isAuthenticated && !profile.id) {
    return null
  }
  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  )
}
ProfileProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default ProfileProvider
